import remodal from 'remodal';

let $locationModal;
let $assessmentModal;

export default  {
	init: function() {
		if($('[data-remodal-id="video-modal"]').length){
			$locationModal = $('[data-remodal-id="video-modal"]').remodal({ hashTracking: false });
			$(document).on('closing', '[data-remodal-id="video-modal"]', function (e) {
				$locationModal.$modal.find('.remodal__content').empty();
			});


			if(document.querySelector('.play-video') !== null){
				document.querySelectorAll('.play-video').forEach(el => {
					el.addEventListener('click', this.openModal, true);
				});
			}
		}

		const assessmentModalId = "assessment-modal";
		if($(`[data-remodal-id="${assessmentModalId}"]`).length) {
			$assessmentModal = $(`[data-remodal-id="${assessmentModalId}"]`).remodal({ hashTracking: false });
			$(document).on('closing', `[data-remodal-id="${assessmentModalId}"]`, function (e) {
				// $locationModal.$modal.find('.remodal__content').empty();
			});

			const ctaSelector = ".zoho-btn";

			if(document.querySelector(ctaSelector) !== null){
				console.log("Assessment buttons exist")
				document.querySelectorAll(ctaSelector).forEach(el => {
					el.addEventListener('click', this.openAssessment, true);
				});
			}
		}
	},
	openAssessment: function (ev) {
		ev.preventDefault();
		$assessmentModal.open();
	},
	openModal : function(ev){
		ev.preventDefault();

		if(typeof ev.currentTarget.dataset.videoId !== 'undefined') {
			let html = `
				<div class="responsive-embed">
				    <!-- Copy & Pasted from YouTube -->
				    <iframe width="560" height="349" src="${ev.currentTarget.dataset.videoId}" frameborder="0" allowfullscreen></iframe>
				</div>
			`;
			// console.log($locationModal.$modal);
			$locationModal.$modal.find('.remodal__content').empty().append(html);
			$locationModal.open();
		}
		// if(ev.target.dataset)
	}
}
